





























import { Component, Vue } from 'vue-property-decorator';
import { DateTime } from 'luxon';
import hexabaseState from '@/store/hexabase';
import userState from '@/store/user';
import Setting from '@/models/settingModel';

import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';

import SingleText from '@/components/common/elements/SingleText.vue';
import Button from '@/components/common/elements/Button.vue';

import appState from '@/store/app';

@Component({
  components: {
    Header,
    SideMenu,
    PageInfoBar,
    SingleText,
    Button
  }
})
export default class SettingManagementView extends Vue {
  private setting = new Setting();  
  private message = '';
  private nowDate = DateTime.local();
  private c1linkageItem: any ={};

  async created() {
    // 管理者権限判定
    if (!userState.isAdmin) {
      this.setError(this.setting.getDefaultRoleErrorMessage());
    }

    try {
      // 管理マスタのC1連携ファイル作成用処理名を検索条件に設定
      const searchItem = appState.options['管理者メニュー']['連携ファイル出力']['C1連携ファイル作成用処理名'];
      const params = {  
        conditions: [
          {
            'id': 'function_name',
            'search_value': [searchItem],
          }
        ],
        'exact_match': true,
        'per_page': 0,
        'page': 1,
        'use_display_id': true
      };
      // CSV出力で使用するアイテム情報をAPIで取得
      const result = await this.setting.getItemSearch(
        hexabaseState.applicationId,
        hexabaseState.datastoreIds['自動化Bot用トラン'],
        params
      );
      // APIで取得した内容からアイテムを検索
      this.c1linkageItem = result.items.find(item => {
        if (item.function_name === searchItem) return item;
      });
    } catch ($e) {
      this.setError($e);
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  private async csvOutput() {
    try {
      this.$store.commit('hexabase/setIsLoading', true);
      const result = await this.setting.changeStatus(
        hexabaseState.applicationId,
        hexabaseState.datastoreIds['自動化Bot用トラン'],
        this.c1linkageItem['i_id'],
        'c1_linkage_file_creation_csv',
        {
          "comment": "C1連携用CSV出力",
          "use_display_id" : true,
          "is_force_update": true
        }
      );
      const blob = result.pre_result !== undefined ? result.pre_result : '';
      const url = window.URL.createObjectURL(
        new Blob([blob], {
          type: 'text/csv' // 例：'application/pdf'
        })
      );
      const link = document.createElement('a');
      link.href = url;
      const nowDate = DateTime.local();
      const year = ( '0000' + nowDate.year ).slice( -4 );
      const month = ( '00' + nowDate.month ).slice( -2 );
      const day = ( '00' + nowDate.day ).slice( -2 );
      const fileName = "keiyaku_info_new_" + year + month + day + '.csv';
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    } catch ($e) {
      this.setError($e);
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  /**
   * APIエラー・プログラムエラーの場合共通エラーダイアログ表示
   * @param errorMessage {string | object}
   */
  private setError(errorMessage: string | object | any): void {
    if (typeof errorMessage === 'object') errorMessage = this.setting.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }

}
